import { useCallback, useRef, useState } from "react";
import { getCompany, getCompanyShareholder } from "services/company-service";

const hasIssuesFor = (shareholderList) =>
    (shareholderList || []).some(
        shareholder =>
            shareholder.biometricStatus !== "A" || shareholder.kycStatus !== "A"
    );

const hasFullyApprovedShareholderIn = (shareholderList) =>
    (shareholderList || []).some(
        shareholder =>
            shareholder.biometricStatus === "A" && shareholder.kycStatus === "A"
    );

export function useShareholderStatus() {
    const [shareholders, setShareholders] = useState([]);
    const [companyData, setCompanyData] = useState(null);
    const [hasIssues, setHasIssues] = useState(false);
    const [allowCompany, setAllowCompany] = useState(false);
    const [loading, setLoading] = useState(false);

    const refresh = useCallback(async (companyId) => {
        if (!companyId) return { hasIssues: false, allowCompany: false, company: null, shareholders: [] };

        setLoading(true);
        try {
            const [company, res] = await Promise.all([
                getCompany(companyId),
                getCompanyShareholder(companyId),
            ]);

            setCompanyData(company);
            setShareholders(res || []);

            const issues = hasIssuesFor(res);
            const hasFullyApproved = hasFullyApprovedShareholderIn(res);
            const allow = !!company?.allowShareholderOperation && hasFullyApproved;

            setHasIssues(issues);
            setAllowCompany(allow);

            return { hasIssues: issues, allowCompany: allow, company, shareholders: res || [] };
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        shareholders,
        companyData,
        hasIssues,
        allowCompany,
        blocked: hasIssues && !allowCompany,
        loading,
        refresh,
    };
}